export const ITEMS_PER_PAGE = 10;

export const CONSUMPTION_TABS = {
  CONSUMPTIONS: 'consumptions',
  RETURNS: 'returns',
};

export const CONSUMPTION_COST_TEXTS = {
  originalCost: 'Costo original de materiales',
  historicalCost: 'Costo histórico de materiales',
  unvaluedItems: 'Ítems sin valorar',
  unitCost: 'Costo original unitario',
  totalCost: 'Costo original total',
  project: 'Vivienda',
  noProject: 'Sin vivienda informada',
  materials: 'Materiales',
};

export const INITIAL_FILTERS = {
  status: '',
  uuid_warehouse: '',
  order_number: '',
  date_from: '',
  date_to: '',
};

export const CONSUMPTION_STATUSES = {
  GENERATED: 'generated',
  CONFIRMED: 'confirmed',
  DELIVERED: 'delivered',
  REVERSED: 'reversed',
  CANCELLED: 'cancelled',
};

export const ACTIVE_CONSUMPTION_STATUSES = [
  CONSUMPTION_STATUSES.GENERATED,
  CONSUMPTION_STATUSES.CONFIRMED,
  CONSUMPTION_STATUSES.DELIVERED,
];

export const BLOCKING_CONSUMPTION_STATUSES = [
  CONSUMPTION_STATUSES.GENERATED,
];

export const GENERATE_CONSUMPTION_ORDER_STATUSES = [
  'stock_available',
  'ready_to_consume',
  'awaiting_transfer',
];

export const CONSUMPTION_STATUS_LABELS = {
  generated: 'Generado',
  confirmed: 'Confirmado',
  delivered: 'Entregado',
  reversed: 'Revertido',
  cancelled: 'Cancelado',
};

export const CONSUMPTION_ITEM_STATUS_LABELS = {
  consumed: 'Consumido',
  reversed: 'Revertido',
};

export const CONSUMPTION_UNIT_STATUS_LABELS = {
  pending_delivery: 'Pendiente de entrega',
  delivered: 'Entregado',
  reversed: 'Revertido',
};

export const INITIAL_GENERATE_CONSUMPTION_STATE = {
  uuid_warehouse: '',
  observations: '',
};

export const INITIAL_DELIVER_CONSUMPTION_STATE = {
  delivery_responsible: '',
  delivery_address: '',
  delivery_date: '',
  delivery_time: '',
  observations: '',
};

export const INITIAL_REVERSE_CONSUMPTION_STATE = {
  reason: '',
  observations: '',
};

export const VALIDATION_RULES = {
  REASON_MAX_LENGTH: 1000,
  OBSERVATIONS_MAX_LENGTH: 1000,
  RESPONSIBLE_MAX_LENGTH: 150,
  ADDRESS_MAX_LENGTH: 255,
};

export const MESSAGES = {
  ERROR: {
    REQUIRED_FIELD: 'Este campo es obligatorio',
    REQUIRED_REASON: 'El motivo es obligatorio',
    REQUIRED_RESPONSIBLE: 'El responsable es obligatorio',
    REQUIRED_ADDRESS: 'La dirección es obligatoria',
    REQUIRED_DATE: 'La fecha es obligatoria',
    REQUIRED_TIME: 'La hora es obligatoria',
  },
};

/** Estado de cada consumo para `StatusChip` (etiqueta y color del tema). */
export const CONSUMPTION_STATUS_CONFIG = {
  [CONSUMPTION_STATUSES.GENERATED]: {
    label: CONSUMPTION_STATUS_LABELS.generated,
    color: 'warning',
  },
  [CONSUMPTION_STATUSES.CONFIRMED]: { label: CONSUMPTION_STATUS_LABELS.confirmed, color: 'info' },
  [CONSUMPTION_STATUSES.DELIVERED]: {
    label: CONSUMPTION_STATUS_LABELS.delivered,
    color: 'success',
  },
  [CONSUMPTION_STATUSES.REVERSED]: { label: CONSUMPTION_STATUS_LABELS.reversed, color: 'default' },
  [CONSUMPTION_STATUSES.CANCELLED]: { label: CONSUMPTION_STATUS_LABELS.cancelled, color: 'error' },
};

/** Estado de cada renglón consumido para `StatusChip`. */
export const CONSUMPTION_ITEM_STATUS_CONFIG = {
  consumed: { label: CONSUMPTION_ITEM_STATUS_LABELS.consumed, color: 'success' },
  reversed: { label: CONSUMPTION_ITEM_STATUS_LABELS.reversed, color: 'default' },
};

/** Opciones del filtro de estado. */
export const CONSUMPTION_STATUS_OPTIONS = Object.entries(CONSUMPTION_STATUS_LABELS).map(
  ([value, label]) => ({ value, label })
);

/** Textos del toolbar de filtros del listado. */
export const CONSUMPTION_FILTER_TEXTS = {
  status: 'Estado',
  warehouse: 'Depósito',
  searchWarehouse: 'Buscar depósito',
  orderNumber: 'Pedido técnico',
  orderNumberPlaceholder: 'Ej: PT-000001',
  dateFrom: 'Desde',
  dateTo: 'Hasta',
};

/** Textos de las tablas de consumos (listado, detalle y generación). */
export const CONSUMPTION_TABLE_TEXTS = {
  number: 'Número',
  order: 'Orden técnica',
  warehouse: 'Depósito',
  date: 'Fecha',
  status: 'Estado',
  responsible: 'Responsable',
  actions: 'Acciones',
  viewDetail: 'Ver detalle',
  printReceipt: 'Imprimir comprobante',
  empty: 'No se encontraron consumos de stock',
  article: 'Artículo',
  quantity: 'Cantidad',
  reservedConsumed: 'Reserva consumida',
  noItems: 'Sin artículos cargados',
  requested: 'Solicitado',
  missing: 'Faltante',
  toConsume: 'A consumir',
};

/** Textos de los campos del diálogo de generación de consumo. */
export const GENERATE_CONSUMPTION_TEXTS = {
  materialsTitle: 'Materiales a consumir',
  warehouse: 'Depósito',
  searchWarehouse: 'Buscar depósito',
  observations: 'Observaciones',
};

/** Textos de los campos del diálogo de reversión de consumo. */
export const REVERSE_CONSUMPTION_TEXTS = {
  reason: 'Motivo',
};
